import React, { useState } from 'react';
import { Modal } from '../ui/Modal';
import { Input } from '../ui/Input';
import { Button } from '../ui/Button';
import { MapPin } from 'lucide-react';
import { useGeolocation } from '../../hooks/useGeolocation';
import { Person } from '../../types';
interface IncidentModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: (incident: any) => void;
  people: Person[];
}
export function IncidentModal({
  isOpen,
  onClose,
  onSave,
  people
}: IncidentModalProps) {
  const {
    location,
    loading: geoLoading,
    getLocation
  } = useGeolocation();
  const [formData, setFormData] = useState({
    title: '',
    category: 'Harassment',
    datetime: new Date().toISOString().slice(0, 16),
    location: '',
    description: '',
    peopleIds: [] as string[]
  });
  const handleSubmit = () => {
    onSave({
      ...formData,
      location: formData.location || location
    });
    onClose();
    // Reset form
    setFormData({
      title: '',
      category: 'Harassment',
      datetime: new Date().toISOString().slice(0, 16),
      location: '',
      description: '',
      peopleIds: []
    });
  };
  return <Modal isOpen={isOpen} onClose={onClose} title="Document New Incident" footer={<div className="flex justify-end space-x-3" data-id="element-162">
          <Button variant="ghost" onClick={onClose} data-id="element-163">
            Cancel
          </Button>
          <Button onClick={handleSubmit} data-id="element-164">Save Incident</Button>
        </div>} data-id="element-161">
      <div className="space-y-4" data-id="element-165">
        <Input label="Incident Title" placeholder="e.g., Verbal harassment in break room" value={formData.title} onChange={e => setFormData({
        ...formData,
        title: e.target.value
      })} data-id="element-166" />

        <div data-id="element-167">
          <label className="block text-sm font-medium text-text-primary mb-1.5" data-id="element-168">
            Category
          </label>
          <select className="w-full px-4 py-2 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-primary-purple" value={formData.category} onChange={e => setFormData({
          ...formData,
          category: e.target.value
        })} data-id="element-169">
            <option value="Harassment" data-id="element-170">Harassment</option>
            <option value="Discrimination" data-id="element-171">Discrimination</option>
            <option value="Injury" data-id="element-172">Injury</option>
            <option value="Unsafe Conditions" data-id="element-173">Unsafe Conditions</option>
            <option value="Other" data-id="element-174">Other</option>
          </select>
        </div>

        <Input type="datetime-local" label="Date & Time" value={formData.datetime} onChange={e => setFormData({
        ...formData,
        datetime: e.target.value
      })} data-id="element-175" />

        <div className="flex gap-2 items-end" data-id="element-176">
          <Input label="Location" placeholder="e.g., Office Kitchen, 2nd Floor" value={formData.location || location} onChange={e => setFormData({
          ...formData,
          location: e.target.value
        })} className="flex-1" data-id="element-177" />
          <Button type="button" variant="secondary" onClick={getLocation} isLoading={geoLoading} className="mb-[2px]" data-id="element-178">
            <MapPin className="w-4 h-4" data-id="element-179" />
          </Button>
        </div>

        <Input multiline label="Description" placeholder="Describe exactly what happened, who was there, and what was said..." value={formData.description} onChange={e => setFormData({
        ...formData,
        description: e.target.value
      })} data-id="element-180" />

        <div data-id="element-181">
          <label className="block text-sm font-medium text-text-primary mb-1.5" data-id="element-182">
            People Involved
          </label>
          <div className="space-y-2 max-h-40 overflow-y-auto border border-gray-200 rounded-lg p-3" data-id="element-183">
            {people.length === 0 ? <p className="text-sm text-gray-500" data-id="element-184">
                No people added yet. Add them in the People tab.
              </p> : people.map(person => <label key={person.id} className="flex items-center space-x-2" data-id="element-185">
                  <input type="checkbox" checked={formData.peopleIds.includes(person.id)} onChange={e => {
              if (e.target.checked) {
                setFormData({
                  ...formData,
                  peopleIds: [...formData.peopleIds, person.id]
                });
              } else {
                setFormData({
                  ...formData,
                  peopleIds: formData.peopleIds.filter(id => id !== person.id)
                });
              }
            }} className="rounded text-primary-purple focus:ring-primary-purple" data-id="element-186" />
                  <span className="text-sm text-gray-700" data-id="element-187">
                    {person.name} ({person.role})
                  </span>
                </label>)}
          </div>
        </div>
      </div>
    </Modal>;
}